function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useApolloClient, useQuery } from "@apollo/client";
import React, { useContext, memo, useEffect, useState, useRef } from "react";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import Alert from "react-bootstrap/Alert";
import moment from "moment-timezone";
import Modal from "react-bootstrap/Modal";
import { FilterContext, UserContext, TrackingContext } from "../../index";
import { convertToHoursAndMinutes } from "../../utils";
import { USER_WORKED_TIME_AND_STATUS_QUERY } from "../query";
import DesktopTaskTimer from "../../ManualPages/DesktopTaskTimer";
export var setStatus = function setStatus(newStatus, organisationId, apolloClient) {
  var options = {
    query: USER_WORKED_TIME_AND_STATUS_QUERY,
    variables: {
      organisationId: organisationId
    },
    fetchPolicy: "cache-and-network"
  };
  var _apolloClient$cache$r = apolloClient.cache.readQuery(options),
    userWorkedTimeAndStatus = _apolloClient$cache$r.userWorkedTimeAndStatus;
  apolloClient.cache.writeQuery(_objectSpread(_objectSpread({}, options), {}, {
    data: {
      userWorkedTimeAndStatus: _objectSpread(_objectSpread({}, userWorkedTimeAndStatus), {}, {
        currentStatus: newStatus
      })
    }
  }));
};
var ModalBody = function ModalBody(props) {
  var displayName = props.displayName,
    stoppedReason = props.stoppedReason;
  var primaryExpirationText;
  switch (stoppedReason) {
    case "trial expired":
      //Block screenshot & app tracking
      primaryExpirationText = "Your Workfolio trial has expired.";
      break;
    case "plan expired":
      primaryExpirationText = "Your Workfolio plan validity has expired.";
      break;
    case "refunded":
      primaryExpirationText = "Your Workfolio plan is inactive.";
      break;
    case "storage full":
      primaryExpirationText = "Your Workfolio storage is full.";
      break;
    default:
      break;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "plan-warning-modal-body-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "plan-warning-modal-body-div-name-text"
  }, "Hi ", displayName, ", "), /*#__PURE__*/React.createElement("div", {
    className: "plan-warning-modal-body-div-main-text"
  }, primaryExpirationText), /*#__PURE__*/React.createElement("div", {
    className: "plan-warning-modal-body-div-secondary-text"
  }, "Please contact your Team Admin to continue using Workfolio."));
};
var ExpirationModal = function ExpirationModal(props) {
  var organisationBilling = props.organisationBilling,
    displayName = props.displayName;
  var _organisationBilling$ = organisationBilling.planStatus,
    planStatus = _organisationBilling$ === void 0 ? "stopped" : _organisationBilling$,
    _organisationBilling$2 = organisationBilling.stoppedReason,
    stoppedReason = _organisationBilling$2 === void 0 ? "trial expired" : _organisationBilling$2;
  // const  planStatus = "stopped"
  // const stoppedReason = "storage full"
  return /*#__PURE__*/React.createElement(Modal, {
    show: stoppedReason,
    animation: true,
    size: "lg",
    backdrop: "static"
  }, /*#__PURE__*/React.createElement(Modal.Body, {
    className: "plan-warning-modal-body"
  }, planStatus === "stopped" ? /*#__PURE__*/React.createElement(ModalBody, {
    displayName: displayName,
    stoppedReason: stoppedReason
  }) : null, /*#__PURE__*/React.createElement("div", {
    className: "plan-warning-modal-footer"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary"
  }, "Exit"))));
};
var Home = function Home(props) {
  var _task$activityType;
  var history = props.history,
    _props$appMaintenance = props.appMaintenanceStatus,
    appMaintenanceStatus = _props$appMaintenance === void 0 ? false : _props$appMaintenance,
    viewMode = props.viewMode,
    setViewMode = props.setViewMode;
  var _useContext = useContext(TrackingContext),
    onStart = _useContext.onStart,
    onStop = _useContext.onStop,
    hasPermission = _useContext.hasPermission,
    requestPermission = _useContext.requestPermission,
    task = _useContext.task;
  console.log(task);
  if (!useContext(FilterContext)) {
    return /*#__PURE__*/React.createElement("div", {
      id: "app-loader",
      style: {
        display: "flex"
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "d-flex flex-column align-items-center m-5"
    }, /*#__PURE__*/React.createElement("p", {
      className: "text-danger mb-0"
    }, "Something went wrong,", " ", /*#__PURE__*/React.createElement("span", {
      style: {
        cursor: "pointer"
      },
      onClick: function onClick() {
        return onStop === null || onStop === void 0 ? void 0 : onStop("stop", "reset_sign_out");
      }
    }, /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement("u", null, "Click here"))), " ", "to fix this issue"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("p", {
      className: "text-primary mb-0",
      style: {
        textAlign: "center"
      }
    }, "If this issue persists,", " ", /*#__PURE__*/React.createElement("span", {
      style: {
        cursor: "pointer"
      },
      onClick: function onClick() {
        return window.ipcRenderer.send("open_chat_support");
      }
    }, /*#__PURE__*/React.createElement("b", null, "Contact us")))));
  }
  var _useContext2 = useContext(FilterContext),
    teamId = _useContext2.teamId,
    organisationId = _useContext2.organisationId,
    organisationSettings = _useContext2.organisationSettings,
    organisationBilling = _useContext2.organisationBilling,
    setOrganisationSettings = _useContext2.setOrganisationSettings;
  var _useContext3 = useContext(UserContext),
    user = _useContext3.user;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    time = _useState2[0],
    setTime = _useState2[1];
  var timer = useRef(null);
  var apolloClient = useApolloClient();
  useEffect(function () {
    requestPermission();
  }, []);
  useEffect(function () {
    if ((!task || task.activityType === "break") && timer.current) {
      clearInterval(timer.current);
      timer.current = null;
      if (!(organisationSettings !== null && organisationSettings !== void 0 && organisationSettings.projectManagement)) {
        return;
      }
    }
    if (task && task.activityType === "start" && !timer.current) {
      timer.current = setInterval(function () {
        setTime(function (prev) {
          return prev + 1;
        });
      }, 1000);
    }
  }, [task]);
  var _useQuery = useQuery(USER_WORKED_TIME_AND_STATUS_QUERY, {
      variables: {
        organisationId: organisationId
      },
      fetchPolicy: "cache-and-network",
      skip: !organisationId
    }),
    data = _useQuery.data,
    error = _useQuery.error,
    loading = _useQuery.loading,
    refetch = _useQuery.refetch;
  useEffect(function () {
    var _data$userWorkedTimeA, _data$userWorkedTimeA2;
    if (loading || error) return;
    var status = data === null || data === void 0 ? void 0 : (_data$userWorkedTimeA = data.userWorkedTimeAndStatus) === null || _data$userWorkedTimeA === void 0 ? void 0 : _data$userWorkedTimeA.currentStatus;
    var stopReason = data === null || data === void 0 ? void 0 : (_data$userWorkedTimeA2 = data.userWorkedTimeAndStatus) === null || _data$userWorkedTimeA2 === void 0 ? void 0 : _data$userWorkedTimeA2.activityReason;
    if (organisationSettings.stealthMode === true || status === "stop" && appMaintenanceStatus === false && (!stopReason || stopReason === "socket_timeout" || stopReason === "socket_disconnect" || stopReason === "system_locked" || stopReason === "system_suspend" || stopReason === "system_offline" || stopReason === "before_update" || stopReason === "server_maintenance")) {
      handleStart(stopReason);
    }
    var taskFromBackend = data === null || data === void 0 ? void 0 : data.currentWorkingTask;
    if (!taskFromBackend || !task) return;
    if (task.taskTimer !== taskFromBackend.workedSeconds) {
      setTime(taskFromBackend.workedSeconds);
    }
  }, [data]);
  useEffect(function () {
    var _window, _window$ipcRenderer;
    (_window = window) === null || _window === void 0 ? void 0 : (_window$ipcRenderer = _window.ipcRenderer) === null || _window$ipcRenderer === void 0 ? void 0 : _window$ipcRenderer.on("refresh", refetch);
  }, []);
  var handleBreak = function handleBreak() {
    var _data$userWorkedTimeA3, _data$userWorkedTimeA4;
    var status = data === null || data === void 0 ? void 0 : (_data$userWorkedTimeA3 = data.userWorkedTimeAndStatus) === null || _data$userWorkedTimeA3 === void 0 ? void 0 : _data$userWorkedTimeA3.currentStatus;
    var workedSecs = data === null || data === void 0 ? void 0 : (_data$userWorkedTimeA4 = data.userWorkedTimeAndStatus) === null || _data$userWorkedTimeA4 === void 0 ? void 0 : _data$userWorkedTimeA4.workedSeconds;
    if (!status || status === "unknown") return;
    var newStatus = status === "break" ? "start" : "break";
    setStatus(newStatus, organisationId, apolloClient);
    var taskInfo = {
      teamId: teamId,
      organisationId: organisationId,
      userId: user.userId,
      updatedAt: new Date(),
      workedSecs: workedSecs,
      taskTimer: workedSecs
    };
    if (status === "break") {
      onStart === null || onStart === void 0 ? void 0 : onStart(taskInfo);
      return;
    }
    onStop === null || onStop === void 0 ? void 0 : onStop(newStatus);
  };
  var handleStop = function handleStop() {
    console.log('Stop timer');
    setStatus("stop", organisationId, apolloClient);
    onStop === null || onStop === void 0 ? void 0 : onStop("stop", "clock_out");
  };
  var handleStart = function handleStart(activityReason, projectDetails, projectDescription) {
    var _data$userWorkedTimeA5, _task$taskTimer;
    window.ipcRenderer.send("disable_screencapture", (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.stoppedReason) || null);
    var workedSecs = data === null || data === void 0 ? void 0 : (_data$userWorkedTimeA5 = data.userWorkedTimeAndStatus) === null || _data$userWorkedTimeA5 === void 0 ? void 0 : _data$userWorkedTimeA5.workedSeconds;
    setStatus("start", organisationId, apolloClient);
    if (projectDetails) {
      projectDetails.description = projectDescription;
    }
    onStart === null || onStart === void 0 ? void 0 : onStart({
      teamId: teamId,
      organisationId: organisationId,
      userId: user.userId,
      updatedAt: new Date(),
      workedSecs: workedSecs,
      taskTimer: workedSecs,
      activityReason: activityReason || null,
      projectId: (projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.projectId) || null,
      projectName: (projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.projectName) || null,
      taskId: (projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.taskId) || null,
      taskName: (projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.taskName) || null,
      description: projectDescription || null
    });
    setTime((_task$taskTimer = task === null || task === void 0 ? void 0 : task.taskTimer) !== null && _task$taskTimer !== void 0 ? _task$taskTimer : workedSecs);
    history === null || history === void 0 ? void 0 : history.push("/overview");
  };
  var greetingMessage = function greetingMessage(date) {
    var hour = date.getHours();
    if (hour >= 2 && hour < 12) {
      return "Good Morning";
    } else if (hour >= 12 && hour < 17) {
      return "Good Afternoon";
    } else if (hour >= 17 && hour <= 23 || hour < 2) {
      return "Good Evening";
    }
  };
  useEffect(function () {
    if (task && (task.activityType === "start" || task.activityType === "break")) {
      history === null || history === void 0 ? void 0 : history.push("/overview");
    }
  }, [data, task]);
  if (loading) {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        display: "grid",
        placeItems: "center",
        height: "calc(100vh - 32px)"
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "sr-only"
    }, "Loading..."));
  }
  if (error) {
    return /*#__PURE__*/React.createElement(Alert, {
      variant: "danger",
      className: "w-50 text-center mx-auto"
    }, "Please check your internet connection or try again later.");
  }
  var userWorkedTimeAndStatus = data === null || data === void 0 ? void 0 : data.userWorkedTimeAndStatus;
  if (!userWorkedTimeAndStatus) {
    return null;
  }
  var workedSeconds = userWorkedTimeAndStatus.workedSeconds,
    currentStatus = userWorkedTimeAndStatus.currentStatus,
    activityReason = userWorkedTimeAndStatus.activityReason;
  var status = (_task$activityType = task === null || task === void 0 ? void 0 : task.activityType) !== null && _task$activityType !== void 0 ? _task$activityType : currentStatus;
  var trialDays;
  if (organisationBilling !== null && organisationBilling !== void 0 && organisationBilling.isTrial) {
    trialDays = Math.ceil(moment.duration(moment(Number(organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.trialEnd)).diff(moment())).asDays());
  }
  return /*#__PURE__*/React.createElement("div", {
    className: !organisationSettings.projectManagement ? "bg-white" : null,
    style: {
      display: "grid",
      placeItems: "center",
      height: "calc(100vh - ".concat(organisationSettings.projectManagement ? "120px" : "32px", " - 55px)"),
      backgroundColor: organisationSettings.projectManagement ? "#ffffff" : null
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-center",
    style: viewMode === "widget" ? _defineProperty({
      width: "90%",
      backgroundColor: "#ffffff",
      borderRadius: 5
    }, "backgroundColor", organisationSettings.projectManagement ? "#ffffff" : null) : {
      width: organisationSettings.projectManagement ? "100%" : "75%",
      backgroundColor: "#ffffff"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-3",
    style: viewMode === "widget" && organisationSettings.projectManagement ? {
      borderBottom: "20px solid #ffffff"
    } : null
  }, user ? /*#__PURE__*/React.createElement("div", {
    style: {
      padding: 10,
      fontSize: 24,
      marginBottom: organisationSettings.projectManagement ? null : 20,
      marginTop: organisationSettings.projectManagement ? "1rem" : null
    }
  }, greetingMessage(new Date()), ", ", user.displayName) : null, status === "unknown" || workedSeconds === 0 || workedSeconds === null || workedSeconds === undefined ? /*#__PURE__*/React.createElement("div", {
    className: "text-black-50"
  }, "Yet to start work for today!") : /*#__PURE__*/React.createElement(React.Fragment, null, !task || status === "stop" ? /*#__PURE__*/React.createElement("h5", {
    className: "text-secondary font-weight-normal",
    style: {
      lineHeight: 1.4
    }
  }, "You have ", /*#__PURE__*/React.createElement("span", {
    className: "text-danger font-weight-bold"
  }, "stopped working"), ".", /*#__PURE__*/React.createElement("br", null), "You have worked for", /*#__PURE__*/React.createElement("span", {
    className: "text-success font-weight-bold"
  }, " ", convertToHoursAndMinutes((userWorkedTimeAndStatus === null || userWorkedTimeAndStatus === void 0 ? void 0 : userWorkedTimeAndStatus.workedSeconds) + (userWorkedTimeAndStatus === null || userWorkedTimeAndStatus === void 0 ? void 0 : userWorkedTimeAndStatus.untrackedSeconds), "full", "seconds"), " "), "today.") : null)), !task || status === "stop" ? !organisationSettings.projectManagement ? /*#__PURE__*/React.createElement(Button, {
    size: "lg",
    variant: "primary",
    onClick: function onClick() {
      return handleStart(activityReason);
    },
    disabled: !hasPermission
  }, "Clock In") : /*#__PURE__*/React.createElement(DesktopTaskTimer, {
    from: "desktop",
    viewMode: viewMode,
    task: task,
    status: status,
    activityReason: activityReason,
    handleStart: handleStart,
    userId: user === null || user === void 0 ? void 0 : user.userId,
    displayName: user === null || user === void 0 ? void 0 : user.displayName,
    handleBreak: handleBreak,
    history: history,
    setViewMode: setViewMode,
    handleFullScreen: props === null || props === void 0 ? void 0 : props.handleFullScreen,
    manualTimeFeature: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.manualTimeFeature
    //  currentWorkingTask={props?.currentWorkingTask}
    //  handleStop={handleStop}
  }) : /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-center"
  }, /*#__PURE__*/React.createElement(Button, {
    size: "lg",
    variant: status === "break" ? "primary" : "warning",
    className: "mx-2",
    onClick: handleBreak,
    disabled: !hasPermission || !navigator.onLine
  }, status === "break" ? "Resume Work" : "Take a Break"), /*#__PURE__*/React.createElement(Button, {
    size: "lg",
    variant: "danger",
    className: "mx-2",
    onClick: handleStop,
    disabled: !hasPermission || !navigator.onLine
  }, "Clock Out"))), viewMode === "widget" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    className: "font-weight-bold",
    style: {
      marginTop: 20,
      width: "70%",
      color: "#00000094",
      background: "#ffffff",
      border: "2px solid #ECF0F1",
      fontSize: 20,
      height: 50,
      borderRadius: 5
    }
    // onClick={props.handleFullScreen}
    ,
    onClick: function onClick() {
      return window.ipcRenderer.send("open_external_link", "https://app.getworkfolio.com/my-work");
    }
  }, "View your work report")) : null);
};
export default /*#__PURE__*/memo(Home);